import React from 'react'
import { connect } from 'cerebral-view-react'
import FlatButton from 'material-ui/FlatButton'
import { t } from '@billes/translator-client'
import CommmonDialog from 'components/common/dialog/common'
import styles from './styles'

const NotAgreedDialog = ({ signals }) => {
  return (
    <CommmonDialog
      renderActions={() => {
        return (
          <div>
            <FlatButton
              style={{ color: '#a8a8a8', fontSize: 13 }}
              label={t('bus-client.previous')}
              onClick={() => {
                signals.app.redoGDRP()
              }}
            />
            <FlatButton
              style={{ color: '#a8a8a8', fontSize: 13 }}
              label={t('bus-client.deleteUser')}
              onClick={() => {
                signals.app.removeUserNotAgreedOnGDPRTerms()
              }}
            />
          </div>
        )
      }}
      renderContent={() => {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html: t('bus-client.gdpr.removeDialogContent')
            }}
          />
        )
      }}
    />
  )
}

const TermsDialog = ({
  signals,
  acceptedGDPR,
  user,
  showAlreadyAgreedGDPRTerms
}) => {
  const closeDialogText = acceptedGDPR
    ? showAlreadyAgreedGDPRTerms ? t('common.close') : t('bus-client.gdpr.ok')
    : user
      ? t('bus-client.gdpr.cancelLoggedIn')
      : t('bus-client.gdpr.cancelLoggedOut')

  return (
    <CommmonDialog
      renderActions={() => {
        return (
          <div>
            <FlatButton
              style={{ color: '#a8a8a8', fontSize: 13 }}
              label={closeDialogText}
              onClick={() => {
                signals.login.closeGDPRDialog()
              }}
            />
          </div>
        )
      }}
      renderContent={() => {
        return (
          <div>
            <span
              dangerouslySetInnerHTML={{
                __html: t('bus-client.gdpr.ingress')
              }}
            />
            <span style={styles.header}>
              {t('bus-client.gdpr.section1.header')}
            </span>
            <div
              dangerouslySetInnerHTML={{
                __html: t('bus-client.gdpr.section1.content')
              }}
            />
            <span style={styles.header}>
              {t('bus-client.gdpr.section2.header')}
            </span>
            <div
              dangerouslySetInnerHTML={{
                __html: t('bus-client.gdpr.section2.content')
              }}
            />
            <span style={styles.header}>
              {t('bus-client.gdpr.section3.header')}
            </span>
            <div
              dangerouslySetInnerHTML={{
                __html: t('bus-client.gdpr.section3.content')
              }}
            />
            <span style={styles.header}>
              {t('bus-client.gdpr.section4.header')}
            </span>
            <div
              dangerouslySetInnerHTML={{
                __html: t('bus-client.gdpr.section4.content')
              }}
            />
            <span style={styles.header}>
              {t('bus-client.gdpr.section5.header')}
            </span>
            <div
              dangerouslySetInnerHTML={{
                __html: t('bus-client.gdpr.section5.content')
              }}
            />
            {showAlreadyAgreedGDPRTerms ? null : (
              <div>
                <input
                  type={'checkbox'}
                  checked={acceptedGDPR}
                  onClick={e => {
                    signals.login.setAcceptGDPR({ value: e.target.checked })
                  }}
                />{' '}
                <span
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    signals.login.toggleAcceptGDPR()
                  }}>
                  {t('bus-client.gdpr.agreeContent')}
                </span>
              </div>
            )}
          </div>
        )
      }}
    />
  )
}

const Dialog = ({
  show,
  showUserNotAgreedOnDBPRTerms,
  acceptedGDPR,
  signals,
  user,
  showAlreadyAgreedGDPRTerms
}) => {
  if (!show && !showUserNotAgreedOnDBPRTerms) {
    return null
  }

  return showUserNotAgreedOnDBPRTerms ? (
    <NotAgreedDialog signals={signals} acceptedGDPR={acceptedGDPR} />
  ) : (
    <TermsDialog
      showAlreadyAgreedGDPRTerms={showAlreadyAgreedGDPRTerms}
      user={user}
      signals={signals}
      acceptedGDPR={acceptedGDPR}
    />
  )
}

export default connect({
  show: 'login.showGDPRDialog',
  showUserNotAgreedOnDBPRTerms: 'app.showUserNotAgreedOnDBPRTerms',
  acceptedGDPR: 'login.acceptedGDPR',
  user: 'client.user',
  showAlreadyAgreedGDPRTerms: 'app.showAlreadyAgreedGDPRTerms'
})(Dialog)



// WEBPACK FOOTER //
// ./src/components/common/dialog/GDPR/index.js